import DateTimePickerTemplate from 'angular-bootstrap-datetimepicker/src/templates/datetimepicker.html';

const unauthenticatedRoutes = [
	'auth.login',
];

const staticLayoutRoutes = [
	'staff.documents.root',
	'supportWorker.documents.root',
];

/* @ngInject */
export default function ($rootScope, $state, $auth, $window, AuthService, $transitions, _, moment, PusherService, AlertService, LayoutService, $timeout, $templateCache, OnlineUsersService, STATUSES, Raven, NoticesService) {
	$transitions.onStart({
		to: (state) => {
			return unauthenticatedRoutes.indexOf(state.name) === -1; // Check if the new route requires authentication
		},
	}, (transition) => {
		if (!AuthService.isLoggedIn()) {
			$auth.logout();

			return transition.router.stateService.target('auth.login', {
				r: $window.location.href,
			});
		}
	});

	$transitions.onStart({
		to: 'supportWorker.**',
	}, (transition) => {
		if (!AuthService.isLoggedIn() || !AuthService.isSupportWorker()) {
			$auth.logout();

			return transition.router.stateService.target('auth.login', {
				r: $window.location.href,
			});
		}
	});

	$transitions.onStart({
		to: 'staff.**',
	}, (transition) => {
		if (!AuthService.isLoggedIn() || !AuthService.isStaff()) {
			$auth.logout();

			return transition.router.stateService.target('auth.login', {
				r: $window.location.href,
			});
		}
	});

	$transitions.onStart({}, (transition) => {
		if (transition._targetState && transition._targetState._definition && staticLayoutRoutes.indexOf(transition._targetState._definition.name) === -1) {
			LayoutService.reset();
		}
	});

	$rootScope.$state      = $state;
	$rootScope.authService = AuthService;
	$rootScope._           = _;
	$rootScope.moment      = moment;
	$rootScope.STATUSES    = STATUSES;

	const checkForTemporaryPassword = () => {
		const user = AuthService.getUser();

		if (user.temporaryPassword && !AuthService.isImpersonating()) {
			$timeout(() => {
				if ($state.current.name !== 'auth.setPassword') {
					$state.go('auth.setPassword', {
						r: $window.location.href,
					});
				}
			});
		}
	};

	const checkForNotices = () => {
		if (!AuthService.isImpersonating()) {
			NoticesService.hasAnyNotViewed()
			              .then((hasAnyNotViewed) => {
				              if (hasAnyNotViewed) {
					              $timeout(() => {
						              if ($state.current.name !== 'auth.setPassword' && $state.current.name !== 'auth.viewNotices') {
							              $state.go('auth.viewNotices', {
								              r: $window.location.href,
							              });
						              }
					              });
				              }
			              });
		}
	};

	AuthService.onLogin(() => {
		checkForTemporaryPassword();
		checkForNotices();

		Raven.setUserContext(AuthService.getUser());

		AuthService.refreshUser()
		           .then(() => {
			           checkForTemporaryPassword();

			           Raven.setUserContext(AuthService.getUser());
		           });
	});

	AuthService.onLogout(() => {
		Raven.setUserContext();
	});

	if (AuthService.isLoggedIn()) {
		AuthService.fireOnLoginCallbacks();

		AuthService.refreshToken()
		           .then((token) => {
			           const payload = AuthService.getAuth()
			                                      .getPayload();

			           const timeExpires = moment.unix(payload.exp);
			           const now         = moment();
			           const difference  = timeExpires.diff(now, 'hours');

			           if (difference <= 8) {
				           AuthService.logout()
				                      .then(() => {
					                      $state.go('auth.login');
				                      });
			           }
		           });
	}

	PusherService.init();
	AlertService.init();
	OnlineUsersService.init();

	$templateCache.put('templates/datetimepicker.html', DateTimePickerTemplate);
};


// WEBPACK FOOTER //
// ./src/js/run.js